module.exports = __webpack_public_path__ + "img/user103.dabf3967.jpg";